import SuccessSnackbarIcon from "../../assets/images/icons/SuccessSnackbarIcon.svg"
import ErrorSnackbarIcon from "../../assets/images/icons/ErrorSnackbarIcon.svg"
import { toast } from "react-toastify";

import { InfoIconSnackBar } from "../Icons/Icons"
import { normalizeError } from "../../utils/errorHelpers"

export const showUndoToast = (text, onUndo) => {
  const message = normalizeError(text)
  let used = false
  toast.success(
    ({ closeToast }) => (
      <div className="flex items-center">
        <img src={SuccessSnackbarIcon} className="icon" alt="" />
        <p className="max-w-[180px] pl-3 text-text-primary">{message}</p>
        <button
          type="button"
          className="ml-3 text-sm font-semibold text-primary-main hover:underline"
          onClick={() => {
            if (used) return
            used = true
            closeToast()
            onUndo()
          }}
        >
          Undo
        </button>
      </div>
    ),
    {
      position: "top-right",
      autoClose: 8000,
      className: "!bg-paper !border !border-divider !rounded-lg flex items-center justify-center",
    }
  )
}

export const showSnackBar = (type, text = 'u forgot to write the text') => {
  // Normalize text to ensure it's always a string
  const message = normalizeError(text)

  let icon = null;

  switch (type) {
    case 'success':
      icon = <img src={SuccessSnackbarIcon} className="icon" alt="" />;
      toast.success(
        <div className="flex items-center">
          {icon}
          <p className="max-w-[230px] pl-3 text-text-primary">{message}</p>
        </div>,
        {
          position: "top-right",
          className: "!bg-paper !border !border-divider !rounded-lg flex items-center justify-center",
        }
      );
      break;
    case 'error':
      icon = <img src={ErrorSnackbarIcon} className="icon" alt="" />;
      toast.error(
        <div className="flex items-center">
          {icon}
          <p className="max-w-[230px] pl-3 text-text-primary">{message}</p>
        </div>,
        {
          position: "top-right",
          className: "!bg-paper !border !border-divider !rounded-lg flex items-center justify-center",
        }
      );
      break;
    case 'alert':
      icon = <InfoIconSnackBar />
      toast.info(
        <div className="flex items-center">
          {icon}
          <p className="max-w-[230px] pl-3 text-text-primary">{message}</p>
        </div>,
        {
          position: "top-right",
          className: "!bg-paper !border !border-divider !rounded-lg flex items-center justify-center",
        }
      );
      break;
    default:
      break;
  }
};